import React from "react";
import { Route, Navigate,Router ,Routes,useLocation} from "react-router-dom";
import AsyncStorageFunc from '../utilities/asyncStorage'
import { useLogin } from "../context/loginProvider";
import { history } from "../utilities/RouterHelper";
export const PublicRoutes = ({ children }) => {
    const location = useLocation();
    const pathname = location.pathname.toLowerCase()
    const [hasPermission, setHasPermission] = React.useState(); // <-- initially undefined
    const  beforeLoginRoutes = ['/login']
    React.useEffect(() => {
      
          AsyncStorageFunc.getData("TOKEN").then(token=>{
            console.log("TOkenIn Private rooute", token)
            if(beforeLoginRoutes.includes(pathname) && token && token !=""){
                history.navigate("/");
            }else{
            }
           
          })
      }, []);
      return children
   
  };

export default PublicRoutes;
 